
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {ImageSelector},
  })
  export default class DlgCompanyNew extends Vue {
    public $refs!: {
      form: any,
    };

    @Action('admin/companies/create') private createCompany!: any;
    @Action('admin/companies/uploadImage') private uploadImage!: any;
    @Action('admin/companies/read') private readCompanies!: any;
    @Getter('common/rules/all') private rules!: any;

    private company: any = {};
    private dialog: boolean = false;
    private loading: boolean = false;
    private valid: boolean = true;
    private companyImage: any = null;
    private imgMissing: boolean = false;

    private async save() {
      if (this.$refs.form.validate() && this.companyImage) {
        this.loading = true;

        this.company.image = await this.uploadImage({image: this.companyImage});

        // Step 1: save company
        const success = await this.createCompany(this.company);
        if (success) {
          await this.readCompanies();
          this.loading = false;
          this.dialog = false;
          this.company = {};
          this.companyImage = null;
          this.$refs.form.resetValidation();
        } else {
          this.loading = false;
        }
      } else {
        this.imgMissing = true;
      }
    }
  }
